// removed by extract-text-webpack-plugin
module.exports = {"edit":"edit_dDkM9","alignRight":"alignRight_3ktc3","inner":"inner_2nfwE","alignLeft":"alignLeft_a03ep","button":"button_2D_D3","zoom":"zoom_1hMhp"};


//////////////////
// WEBPACK FOOTER
// ./app/components/moment-edit/styles.scss
// module id = 463
// module chunks = 1